<div class="dialog-setup">
  <button class="close" mat-button (click)="onNoClick()">X</button>
  <div class="profile-title">
    <h2 class="profile-head">Change Password</h2>
  </div>
  <div class="profile-body">
    <!-- Edit Button  -->
    <!-- Username, Name, Surname, Email, Phone Number -->

    <fieldset>
      <mat-form-field appearance="standard" color="accent">
        <mat-label>Current Password</mat-label>
        <input [type]="hidePW1 ? 'password' : 'text'" matInput [formControl]="oldpasswordFormControl"
          autocomplete="new-password">
        <mat-icon class="suffix-icon" matSuffix (click)="hidePW1 = !hidePW1">
          {{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
        <mat-error *ngIf="passwordFormControl.hasError('required')">
          Password is required
        </mat-error>
        <mat-error *ngIf="passwordFormControl.hasError('minlength')">
          Minimum 8 characters
        </mat-error>

      </mat-form-field>
    </fieldset>

    <fieldset>
      <mat-form-field class="gate-full-width" appearance="standard" color="accent">
        <mat-label>Password</mat-label>
        <input [type]="hidePW2 ? 'password' : 'text'" matInput [formControl]="passwordFormControl"
          autocomplete="new-password">
        <mat-icon class="suffix-icon" matSuffix (click)="hidePW2 = !hidePW2">
          {{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
        <mat-error *ngIf="passwordFormControl.hasError('required')">
          Password is required
        </mat-error>
        <mat-error *ngIf="passwordFormControl.hasError('minlength')">
          Minimum 8 characters
        </mat-error>
      </mat-form-field>
    </fieldset>

    <fieldset>
      <mat-form-field class="gate-full-width" appearance="standard" color="accent">
        <mat-label>Password</mat-label>
        <input [type]="hidePW3 ? 'password' : 'text'" matInput [formControl]="passwordRetypeFormControl">
        <mat-icon class="suffix-icon" matSuffix (click)="hidePW3 = !hidePW3">
          {{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
        <mat-error *ngIf="passwordFormControl.hasError('required')">
          Password is required
        </mat-error>
        <mat-error *ngIf="passwordFormControl.hasError('minlength')">
          Minimum 8 characters
        </mat-error>
      </mat-form-field>
    </fieldset>




  </div>
  <div class="profile-footer">
    <button mat-raised-button class="btn-block change-pw-button" (click)="changePassword()">Change Password</button>

  </div>
</div>
